export const getLightIconName = (iconName: string) => `${iconName}Light`;
